import { render, staticRenderFns } from "./examinationAnswerResult.vue?vue&type=template&id=15647f49&scoped=true&"
import script from "./examinationAnswerResult.vue?vue&type=script&lang=js&"
export * from "./examinationAnswerResult.vue?vue&type=script&lang=js&"
import style0 from "./examinationAnswerResult.vue?vue&type=style&index=0&id=15647f49&scoped=true&lang=scss&"
import style1 from "./examinationAnswerResult.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15647f49",
  null
  
)

export default component.exports